import React from 'react';
import { Link } from 'react-router-dom';
import styles from './RefundPolicyPage.module.css';

const RefundPolicyPage: React.FC = () => {
  return (
    <div className={styles.refundPolicyPage}>
      <div className={styles.refundPolicyContainer}>
        {/* Header */}
        <div className={styles.refundPolicyHeader}>
          <div className={styles.refundPolicyIcon}>
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h1 className={styles.refundPolicyTitle}>
            Refund Policy
          </h1>
          <p className={styles.refundPolicySubtitle}>
            All Sales Are Final - Please review our policy carefully before completing your
            purchase.
          </p>
        </div>

        {/* Policy Content */}
        <div className={styles.refundPolicyContent}>
          <div className={styles.refundPolicySection}>
            <h2 className={styles.refundPolicySectionTitle}>
              Refund Policy – All Sales Are Final
            </h2>

            <p className={styles.refundPolicyText}>
              Thank you for supporting our brand! We&apos;re so grateful for every order and want to
              make sure our policies are clear and transparent before you complete your purchase.
            </p>

            <div className={styles.refundPolicyNotice}>
              <h3 className={styles.refundPolicyNoticeTitle}>Important Notice</h3>
              <p className={styles.refundPolicyNoticeText}>
                Please note that all sales are final. We do not offer refunds, returns, or exchanges
                under any circumstances. This policy applies to all products and all orders, without
                exception.
              </p>
            </div>

            <h3 className={styles.refundPolicySectionTitle}>Why All Sales Are Final</h3>
            <p className={styles.refundPolicyText}>
              Because each item is made to order, we begin production only after the website has
              closed, based on the total quantity of items sold. This allows us to minimize waste
              and produce intentionally—but it also means that we cannot make adjustments,
              cancellations, or refunds once an order has been placed.
            </p>

            <h3 className={styles.refundPolicySectionTitle}>
              Production & Shipping Timeline
            </h3>
            <div className={styles.refundPolicyInfoBox}>
              <p className={styles.refundPolicyInfoText}>
                This refund policy directly supports our Shipping Policy, which explains that
                production takes approximately 2–3 weeks after the shop closes. After production is
                complete, orders are packed and shipped, and you&apos;ll receive tracking details
                via email. Please expect your order to arrive within 3–4 weeks total from the
                website closing date.
              </p>
            </div>

            <h3 className={styles.refundPolicySectionTitle}>Order Agreement</h3>
            <p className={styles.refundPolicyText}>
              By placing an order, you acknowledge and agree to the following:
            </p>
            <div className={styles.refundPolicyListBox}>
              <ul className={styles.refundPolicyList}>
                <li>You have reviewed all product details, including size, style, and color.</li>
                <li>You understand the timeline for production and shipping.</li>
                <li>
                  You agree that no refunds, returns, or exchanges will be granted for any reason,
                  including but not limited to incorrect sizing, address errors, order delays, or a
                  change of mind.
                </li>
              </ul>
            </div>

            <h3 className={styles.refundPolicySectionTitle}>Before You Order</h3>
            <div className={styles.refundPolicyWarningBox}>
              <p className={styles.refundPolicyWarningText}>
                We ask that you double-check your order details and shipping address before
                submitting your purchase. If you catch a mistake before the website closes, please
                contact us immediately and we&apos;ll do our best to help—but once the site closes,
                orders are final and locked in.
              </p>
            </div>

            <h3 className={styles.refundPolicySectionTitle}>Our Commitment</h3>
            <p className={styles.refundPolicyText}>
              We appreciate your understanding and support of our small business and made-to-order
              model. Your purchase helps us create responsibly and deliver unique items with care
              and purpose.
            </p>

            <h3 className={styles.refundPolicySectionTitle}>Questions & Concerns</h3>
            <div className={styles.refundPolicyContactBox}>
              <p className={styles.refundPolicyContactText}>
                If you have any questions or concerns, please reach out to us before placing your
                order. We&apos;re happy to help!
              </p>
              <div className={styles.refundPolicyContactDetails}>
                <p>
                  <span className={styles.refundPolicyContactItem}>Email:</span> support@appelt-bonfire.com
                </p>
                <p>
                  <span className={styles.refundPolicyContactItem}>Phone:</span> +1 (555) 123-4567
                </p>
                <p>
                  <span className={styles.refundPolicyContactItem}>Hours:</span> Monday - Friday, 9:00 AM - 6:00 PM EST
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Back to Shopping */}
        <div className={styles.refundPolicyBackButton}>
          <Link
            to="/"
            className={styles.backToShoppingButton}
          >
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
